import React from 'react'
import { Badge, CustomModal } from '../../../../../components'
import * as colors from '../../../../../assets/js/colors'
import { ResultadoResposta } from '../../../../../constants/checklist-operacional'
import ChecklistForm from '../../shared/ChecklistForm/ChecklistForm'
import { calcularResultado } from '../../shared/respostas.util'
import useModalPreviewChecklist from './ModalPreviewChecklistHook'

const styles = {
  aviso: { color: colors.gray, fontSize: '0.8rem', marginBottom: 15 },
  conteudo: { maxHeight: '70vh', overflow: 'auto' },
  resumo: { display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 20 },
}

export default function ModalPreviewChecklist({ show, payload, onClose }) {
  const { state, localDispatch } = useModalPreviewChecklist()
  const { respostas } = state

  const resultado = calcularResultado(payload, respostas)
  const semResposta = resultado.scored - resultado.success - resultado.fail - resultado.neutral

  return (
    <CustomModal
      header="Pré-visualização do Checklist"
      isVisible={show}
      onClose={onClose}
      width="85vw"
      contentStyle={styles.conteudo}
      maximizable
    >
      <div style={styles.aviso}>
        Simulação do preenchimento: as respostas marcadas aqui não são gravadas.
      </div>
      <ChecklistForm
        checklist={payload}
        respostas={respostas}
        onChange={localDispatch.onRespostasChange}
        mostrarClassificacao
        mostrarTitulo
      />
      <div style={styles.resumo}>
        <Badge color={ResultadoResposta.success.color}>Sucesso: {resultado.success}</Badge>
        <Badge color={ResultadoResposta.fail.color}>Falha: {resultado.fail}</Badge>
        <Badge color={ResultadoResposta.neutral.color}>Neutro: {resultado.neutral}</Badge>
        <Badge color={colors.azul}>Sem resposta: {semResposta}</Badge>
      </div>
    </CustomModal>
  )
}
